<template>
  <div class="jinshatan-result-page">
    <img class="banner-img" src="/static/images/jst/banner.png" />

    <div class="content-area">
      <div class="verification-status">
        <div class="status-item">
          <i class="fa-solid fa-bag-shopping status-icon"></i>
          <span class="status-label">产品名称：</span>
          <span class="status-value">{{ productName }}</span>
        </div>
        <div class="status-item">
          <i class="fa-solid fa-list-ol status-icon"></i>
          <span class="status-label">产品型号：</span>
          <span class="status-value">{{ productStandard }}</span>
        </div>
        <div class="status-item">
          <i class="fa-regular fa-clock status-icon"></i>
          <span class="status-label">首次查询时间：</span>
          <span class="status-value">{{ firstQueryTime }}</span>
        </div>
        <div class="status-item">
          <i class="fa-regular fa-clock status-icon"></i>
          <span class="status-label">上次查询时间：</span>
          <span class="status-value">{{ preQueryTime || firstQueryTime }}</span>
        </div>
      </div>

      <div class="points-btn-container" v-if="showPointsBtn">
        <div class="points-btn-content">
          <span class="points-btn-text">领取积分 参与活动</span>
          <button class="points-btn" @click="goToJoin">点击</button>
        </div>
      </div>

      <div class="activity-rules" v-if="activityRule">
        <h4 class="rules-title">活动规则</h4>
        <div class="rules-content" v-html="activityRule"></div>
      </div>
    </div>

    <!-- 模态框 -->
    <div class="modal-overlay" v-if="showModal">
      <div class="modal-card">
        <div class="modal-icon-container">
          <i class="fa-solid fa-exclamation-triangle"></i>
        </div>
        <div class="modal-title">{{ modalMessage }}</div>

        <button class="modal-btn" @click="closeModal">重新查询</button>
      </div>
    </div>

    <!-- 参与活动模态框 -->
    <div class="join-modal-overlay" v-if="showJoinModal">
      <div class="join-modal-card">
        <div class="join-modal-top-text">查询的青西金啤产品为正品，请放心使用!</div>
        <div class="join-modal-icon-container">
          <i class="fa-solid fa-check" v-if="pointsClaimed"></i>
          <i class="fa-solid fa-coins" v-if="!pointsClaimed"></i>
        </div>
        <div class="join-modal-title">{{ joinModalTitle }}</div>
        <div class="join-modal-points" v-if="joinModalPoints > 0">恭喜获得{{ joinModalPoints }}积分</div>

        <wx-open-launch-weapp class="join-modal-btn" :appid="miniAppId" :username="miniAppOriginalId"
          :path="miniAppPage">
          <script type="text/wxtag-template">
            <span style="font-size: 14px; color: white; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">前往商城</span>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<style scoped>
.jinshatan-result-page {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
}

.banner-img {
  width: 100vw;
  height: auto;
  display: block;
  z-index: 1;
}

.content-area {
  position: relative;
  z-index: 2;
  padding: 2.67vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10vh;
}

.verification-status {
  width: 80vw;
  text-align: left;
  margin-bottom: 2vw;
  margin-top: 3vh;
  background-color: #FFFFFF;
  padding: 6.25vw;
  border-radius: 2vw;
  box-shadow: 0 0.27vw 1.07vw rgba(0, 0, 0, 0.08);
}

.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 2.75vw;
  font-size: 3.5vw;
  color: #333;
  flex-wrap: nowrap;
}

.status-icon {
  color: #D32F2F;
  margin-right: 1.66vw;
  width: 3vw;
  text-align: center;
  font-size: 4vw;
}

.status-label {
  font-weight: bold;
  color: #555;
  flex-shrink: 0;
}

.status-value {
  font-weight: normal;
  color: #333;
  flex: 1;
  white-space: nowrap;
}

.success-message {
  margin-top: 1.33vw;
  padding: 1.33vw;
  font-size: 2.13vw;
  color: #666;
  background-color: #FFF3E0;
  border-left: 0.4vw solid #FF9800;
  border-radius: 0.53vw;
  line-height: 1.5;
}

.points-btn-container {
  width: 80vw;
  margin-top: 3vw;
  margin-bottom: 3vw;
}

.points-btn-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #C62828 0%, #EF5350 100%);
  border-radius: 3.33vw;
  padding: 3vw 2.85vw;
  box-shadow: 0 0.53vw 1.33vw rgba(198, 40, 40, 0.3);
}

.points-btn-text {
  color: white;
  font-size: 4vw;
  font-weight: bold;
  margin-left: 2vw;
}

.points-btn {
  background: rgb(254, 115, 2);
  color: #C62828;
  border: none;
  padding: 2vw 4vw;
  border-radius: 2.67vw;
  font-size: 3.5vw;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 0.27vw 0.67vw rgba(0, 0, 0, 0.2);
}

.activity-rules {
  width: 80vw;
  margin-top: 1.33vw;
  padding: 2vw;
  background-color: #F5F5F5;
  border-radius: 1.07vw;
}

.rules-title {
  margin: 0 0 1.33vw 0;
  color: #666;
  font-size: 4vw;
  font-weight: bold;
}

.rules-list {
  margin: 0;
  padding-left: 2.5vw;
  color: #999;
  font-size: 2.8vw;
  line-height: 1.8;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-card {
  background-color: white;
  border-radius: 2vw;
  padding: 5vw;
  width: 80vw;
  height: 32vh;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.2);
}

.modal-top-text {
  font-size: 3.5vw;
  color: #333;
  margin: 4vw 0;
}

.modal-icon-container {
  display: flex;
  justify-content: center;
  margin: 5vw 0;
}

.modal-icon-container i {
  font-size: 16vw;
  color: #C62828;
  margin: 0 1.5vw;
}

.modal-title {
  font-size: 4vw;
  font-weight: bold;
  color: #333;
  margin: 4vw 0;
}

.modal-btn {
  background-color: #C62828;
  color: white;
  border: none;
  border-radius: 1vw;
  padding: 2vw 4vw;
  font-size: 3vw;
  cursor: pointer;
  margin-top: 4vw;
}

.join-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.join-modal-card {
  width: 80vw;
  background-color: #333;
  border-radius: 1.6vw;
  padding: 4vw 2.67vw;
  text-align: center;
  color: white;
  box-shadow: 0 1.33vw 3.33vw rgba(0, 0, 0, 0.5);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.join-modal-top-text {
  font-size: 3.4vw;
  font-weight: bold;
  color: #ccc;
  margin-bottom: 2.67vw;
  margin-top: 3vh;
  width: 100%;
  text-align: center;
}

.join-modal-icon-container {
  margin-bottom: 2vw;
  margin-top: 4vw;
  font-size: 8vw;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  width: 15vw;
  height: 15vw;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.join-modal-icon-container i {
  margin: 0 1vw;
}

.join-modal-title {
  font-size: 4.5vw;
  font-weight: bold;
  margin-bottom: 2vw;
  margin-top: 5vw;
  color: #fff;
}

.join-modal-points {
  font-size: 5vw;
  font-weight: bold;
  color: #fff;
  margin-bottom: 2vw;
  margin-top: 2vw;
}

.join-modal-btn {
  width: 50%;
  height: 37px;
  padding: 1.5vw;
  margin-top: 3vh;
  border: none;
  border-radius: 3.33vw;
  background-color: #D32F2F;
  color: white;
  font-size: 2.6vw;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 0.53vw 1.33vw rgba(211, 47, 47, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { queryAnti, getInfoByCode, getWechatAuth, getJSSDK, getScoreConfig, getTemplate, registerByOpenId, joinActivity as joinActivityApi } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'JinShaTanResult',
  data() {
    return {
      queryCount: '',
      firstQueryTime: '',
      preQueryTime: '',
      deptId: '',
      antiCode: '',
      eno: process.env.ENV_NUM === '1' ? '138791906387' : '138310353396',
      appId: process.env.ENV_NUM === '1' ? 'wxbc22565b3e7a59fd' : 'wxbc22565b3e7a59fd',
      showPointsBtn: true,
      showModal: false,
      modalMessage: '',
      productName: '',
      productStandard: '',
      wyAuthCode: '',
      isJoin: 0,
      activityId: 0,
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      userToken: '',
      points: 0,
      pointsClaimed: false,
      showJoinModal: false,
      joinModalTitle: '',
      joinModalPoints: 0,
      activityRule: ''
    }
  },
  mounted() {
    this.getWxJs();

    // 从路由参数中获取查询数据
    this.antiCode = this.$route.query.c;
    this.wyAuthCode = this.$route.query.wyAuthCode;
    this.isJoin = this.$route.query.isJoin;

    // 调用防伪查询接口获取数据
    this.queryAntiCode();
  },
  methods: {
    goToJoin() {
      const redirectUrl = window.location.origin + '/jst/result';
      const params = new URLSearchParams();
      params.append('eno', this.eno);
      params.append('c', this.antiCode);
      params.append('deptId', this.deptId);
      params.append('isJoin', 1);
      const fullRedirectUrl = redirectUrl + '?' + params.toString();

      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err => {
        alert("获取微信授权失败" + err);
      });
    },
    async queryAntiCode() {
      try {
        const res = await queryAnti(this.antiCode, this.eno);
        const data = res.data;

        if (data == null || data.code == "500") {
          this.modalMessage = "查询异常，请重新扫描防伪码进行查询";
          this.showModal = true;
          this.showPointsBtn = false;
          return;
        }

        // 处理查询结果
        const replyCode = data.data.replyCode;

        if (replyCode === "300101" || replyCode === "300102") {
          // 正品情况
          this.queryCount = data.data.queryCount || '';
          this.firstQueryTime = data.data.firstQueryTime || '';
          this.preQueryTime = data.data.preQueryTime || '';
          this.deptId = data.data.deptId || '';
          this.showPointsBtn = true;

          // 获取产品信息
          this.queryCodeInfo();

          // 获取活动规则
          await this.getTemplate();
          await this.getScoreConfig();
          // 当wyAuthCode不为空，并且isJoin=1时，调用参与活动的方法
          if (this.wyAuthCode && this.isJoin == 1) {
            this.joinActivity();
          }
        } else if (replyCode === "300106") {
          // 防伪码不存在，显示模态框
          this.modalMessage = data.message || "您查询的数码不存在！";
          this.showModal = true;
          this.showPointsBtn = false;
        } else {
          // 其他情况，显示模态框
          this.modalMessage = data.message || "查询结果异常，请联系客服";
          this.showModal = true;
          this.showPointsBtn = false;
        }
      } catch (error) {
        console.error('防伪查询失败:', error);
        this.modalMessage = "查询失败，请稍后重试";
        this.showModal = true;
        this.showPointsBtn = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.$router.push('/jst');
    },
    async queryCodeInfo() {
      try {
        const res = await getInfoByCode(this.antiCode);
        console.log('查询的码结果为：', res);
        const data = res.data;

        if (data.code == "200" && data.data != null) {
          this.productStandard = data.data.productStandard;
          this.productName = data.data.productName;
        }
      } catch (error) {
        console.error('获取产品信息失败:', error);
      }
    },
    async getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async joinActivity() {
      if (this.activityId) {
        await this.registerUser();
      }
    },
    async getScoreConfig() {
      try {
        const res = await getScoreConfig(this.deptId);
        if (res.data.data != null) {
          this.shopUrl = res.data.data.shopUrl;
          const data = this.shopUrl.split('|');
          this.miniAppId = data[0];
          this.miniAppOriginalId = data[1];
          this.miniAppPage = data[2];
        }
      } catch (error) {
        console.error('获取积分配置失败:', error);
      }
    },
    async getTemplate() {
      try {
        const res = await getTemplate(this.deptId);
        if (res.data.data != null) {
          this.activityId = res.data.data.activityId;
          this.activityRule = res.data.data.activityRule || '';
        } else {
          alert("活动未开始或已下线，敬请留意最新活动信息");
        }
      } catch (error) {
        console.error('获取模板失败:', error);
        alert("活动未开始或已下线，敬请留意最新活动信息");
      }
    },
    async registerUser() {
      try {
        const res = await registerByOpenId(this.eno, this.wyAuthCode);
        if (res.data.code === "200") {
          console.log('用户注册成功:', res.data.data);
          this.userToken = res.data.data.token;
          await this.doJoinActivity();
        } else {
          alert("用户注册失败: " + (res.data.message || "未知错误"));
        }
      } catch (error) {
        console.error('注册用户失败:', error);
        alert("注册用户失败，请重试");
      }
    },
    async doJoinActivity() {
      try {
        const data = {
          code: this.antiCode,
          activityId: this.activityId,
          authCode: this.wyAuthCode,
          userToken: this.userToken
        };

        const result = await joinActivityApi(data);
        if (result.data.code === "200") {
          console.log('参与活动成功:', result.data.data);
          this.points = result.data.data.giftValue;
          this.joinModalTitle = '';
          this.joinModalPoints = this.points;
          this.showJoinModal = true;
          this.showPointsBtn = false;
        } else if (result.data.code === "500001") {
          console.log('积分已领取');
          this.pointsClaimed = true;
          this.joinModalTitle = '积分已被领取';
          this.joinModalPoints = 0;
          this.showJoinModal = true;
          this.showPointsBtn = false;
        } else {
          alert("参与活动失败，请联系客服处理");
        }
      } catch (error) {
        console.error('参与活动失败:', error);
        alert("参与活动失败，请联系客服处理");
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JinShaTan/Result.vue